import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FormProvider, useForm } from "react-hook-form";
import StickyToolbar from "../../../../../StickyToolbar";
import Select from "react-select";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import {
    ListarEmpreendimentosComObraController,
    ListarEmpreendimentosController,
    ListarUnidadesPorEmpreendimentoController,
} from "../../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import SelectCategoriaAtendimento from "../../../../Forms/SelectCategoriaAtendimento";
import { useModuloInfo } from "../../../../../../Context/ModuloInfo";
import LazySelect from "../../../../Forms/LazySelect";
import { ListarUsuariosController } from "../../../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import {
    ListarEtapasController,
    ListarEtapasEntregaDeChavesController,
    ListarEtapasPorCategoriaETipoCasoController,
} from "../../../../../../Controllers/Geral/Etapas/EtapasControllers";
import { ACESSOS } from "../../../../../../Routes/Acessos";
import { ModuloAtendimento } from "../../../../Atendimento";
import SelectComBusca from "../../../../Forms/SelectComBusca";
import { ListarCategoriaRepasseController } from "../../../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";

interface IFiltroAtendimentosDoCliente {
    filter: any;
    FILTRO_ATENDIMENTOS_DO_CLIENTE: string | null;
    handleDateChange: (formData: any) => void;
    filtroInicial: any;
    setFilter: (filter: any) => void;
    setPage: (page: number) => void;
    setIdEmpreendimento: Dispatch<SetStateAction<string | number[]>>;
    setCategoriaAtendimento: Dispatch<SetStateAction<number[]>>;
    categoriaAtendimento: number[];
    setValueEtapa: Dispatch<
        SetStateAction<
            | {
                  label: string;
                  value: number;
              }[]
            | null
        >
    >;
    valueEtapa:
        | {
              label: string;
              value: number;
          }[]
        | null;
    dsModulo: ModuloAtendimento;
}
export default function FiltroAtendimentosDoCliente(
    props: IFiltroAtendimentosDoCliente
) {
    const { id } = useModuloInfo();
    const FormMethods = useForm();

    const { register, handleSubmit, reset, control, setValue } = FormMethods;

    const selectInputRef = useRef<any>();
    const etapaRef = useRef<any>();

    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const limparFiltros = () => {
        selectInputRef.current?.clearValue();
        etapaRef.current?.clearValue();
        props.setCategoriaAtendimento([]);
        props.setValueEtapa(null);
    };

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: lstEtapasVistoria } = useAsyncEffect(
        () => ListarEtapasEntregaDeChavesController(),
        []
    );

    const etapasOptionsVistoria = lstEtapasVistoria?.map((e) => ({
        label: e.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
        value: e.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
    }));

    const { value: lstEtapas } = useAsyncEffect(async () => {
        if (props.categoriaAtendimento.length > 0) {
            return ListarEtapasPorCategoriaETipoCasoController(
                ACESSOS.ATENDIMENTO.ID_MODULO,
                props.categoriaAtendimento
            );
        }
    }, [props.categoriaAtendimento]);

    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );

    const etapasOptions = lstEtapas?.map((e) => ({
        label: e.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
        value: e.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
    }));

    const { value: lstEtapasAssistTec } = useAsyncEffect(
        () => ListarEtapasController(ACESSOS.ASSISTENCIA.ID_MODULO ?? 0, 0),
        []
    );

    useEffect(() => {
        setOptions(() =>
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [listarEmpreendimentos]);

    return (
        <>
            <StickyToolbar active={!!props.FILTRO_ATENDIMENTOS_DO_CLIENTE}>
                <FormProvider {...FormMethods}>
                    <form
                        className="form-group row"
                        onSubmit={handleSubmit(props.handleDateChange)}
                    >
                        {props.dsModulo === "Atendimento" && (
                            <>
                                <div className="col-12 mt-3">
                                    <label>Data Inicial</label>
                                    <div className="row">
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_INICIAL_IN
                                                }
                                                name="DT_INICIAL_IN"
                                                ref={register()}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_INICIAL_FN
                                                }
                                                name="DT_INICIAL_FN"
                                                ref={register()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Data Final</label>
                                    <div className="row">
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_FINAL_IN
                                                }
                                                name="DT_FINAL_IN"
                                                ref={register()}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_FINAL_FN
                                                }
                                                name="DT_FINAL_FN"
                                                ref={register()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Empreendimento</label>
                                    <Select
                                        name="ID_EMPREENDIMENTO"
                                        ref={selectInputRef}
                                        options={options}
                                        isClearable
                                        isMulti
                                        onChange={(e) => {
                                            props.setIdEmpreendimento(
                                                e.map((value) => value?.value)
                                            );
                                        }}
                                        components={{
                                            DropdownIndicator: () => null,
                                            IndicatorSeparator: () => null,
                                        }}
                                        styles={customStyles}
                                        placeholder={""}
                                        noOptionsMessage={() => "Nenhuma opção"}
                                    />
                                </div>

                                <div className="col-12 mt-3">
                                    <label>Categoria de Atendimento</label>
                                    <SelectCategoriaAtendimento
                                        ID_MODULO={id}
                                        setIdCategoria={(c) =>
                                            props.setCategoriaAtendimento(
                                                c as SetStateAction<number[]>
                                            )
                                        }
                                        filterTreeNode={(input, treeNode) =>
                                            treeNode?.props.title
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >=
                                            0
                                        }
                                        showSearch
                                        control={control}
                                        value={props.categoriaAtendimento}
                                        multiple
                                    />
                                </div>

                                <div className="col-12 mt-3">
                                    <label>Etapa</label>
                                    <Select
                                        name="ID_ETAPA_CATEGORIA_ATENDIMENTO"
                                        placeholder={""}
                                        menuPlacement="auto"
                                        noOptionsMessage={() => "Nenhuma opção"}
                                        styles={customStyles}
                                        options={etapasOptions}
                                        value={props.valueEtapa}
                                        onChange={(e) =>
                                            props.setValueEtapa(
                                                e as SetStateAction<
                                                    | {
                                                          label: string;
                                                          value: number;
                                                      }[]
                                                    | null
                                                >
                                            )
                                        }
                                        components={{
                                            DropdownIndicator: () => null,
                                            IndicatorSeparator: () => null,
                                        }}
                                        isClearable
                                        isMulti
                                    />
                                </div>
                            </>
                        )}

                        {props.dsModulo === "Cobranca" && (
                            <>
                                <div className="col-12 mt-3">
                                    <label>Data Inicial</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={
                                            props.filter?.DT_PERIODO_INICIO
                                        }
                                        name="data_inicio"
                                        ref={register({
                                            required: "Insira a data inicial",
                                        })}
                                    />
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Data Final</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={
                                            props.filter?.DT_PERIODO_FIM
                                        }
                                        name="data_fim"
                                        ref={register({
                                            required: "Insira a data final",
                                        })}
                                    />
                                </div>
                                <div className="col-12 mt-3">
                                    <LazySelect
                                        label={"Empreendimento"}
                                        className="form-control"
                                        name="ID_EMPREENDIMENTO"
                                        defaultValue={
                                            props.filter?.ID_EMPREENDIMENTO
                                        }
                                        registerOptions={{
                                            valueAsNumber: true,
                                        }}
                                        {...FormMethods}
                                        controller={
                                            ListarEmpreendimentosComObraController
                                        }
                                        getDS={(e) => e.DS_EMPREENDIMENTO}
                                        getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                                        ref={register()}
                                    >
                                        <option value={0}></option>
                                    </LazySelect>
                                </div>
                                <div className="col-12 mt-3">
                                    <LazySelect
                                        label={"Unidade"}
                                        className="form-control"
                                        name="ID_UNIDADE"
                                        registerOptions={{
                                            valueAsNumber: true,
                                        }}
                                        defaultValue={props.filter?.ID_UNIDADE}
                                        controller={
                                            ListarUnidadesPorEmpreendimentoController
                                        }
                                        fatherName={"ID_EMPREENDIMENTO"}
                                        getDS={(u) => u.DS_UNIDADE}
                                        getKeyValue={(u) => u.ID_UNIDADE}
                                        ref={register()}
                                        {...FormMethods}
                                    >
                                        <option value={0}></option>
                                    </LazySelect>
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Status do Caso</label>
                                    <select
                                        className="form-control"
                                        name="DS_STATUS_CASO"
                                        defaultValue={
                                            props.filter?.DS_STATUS_CASO
                                        }
                                        ref={register({
                                            valueAsNumber: true,
                                        })}
                                    >
                                        <option></option>
                                        <option value={0}>Aberto</option>
                                        <option value={1}>Fechado</option>
                                    </select>
                                </div>
                            </>
                        )}

                        {props.dsModulo === "AssistenciaTecnica" && (
                            <>
                                <div className="col-12 mt-3">
                                    <label>Data Início</label>
                                    <div className="row">
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                defaultValue={
                                                    props.filter?.DT_INICIO_IN
                                                }
                                                type="date"
                                                name="DT_INICIO_IN"
                                                ref={register()}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                defaultValue={
                                                    props.filter?.DT_INICIO_FN
                                                }
                                                type="date"
                                                name="DT_INICIO_FN"
                                                ref={register()}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 mt-3">
                                    <label>Data Fim</label>
                                    <div className="row">
                                        <div className="col-6">
                                            <input
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_FIM_IN?.split(
                                                        "T"
                                                    )[0]
                                                }
                                                className="form-control"
                                                name="DT_FIM_IN"
                                                ref={register()}
                                            />
                                        </div>

                                        <div className="col-6">
                                            <input
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_FIM_FN?.split(
                                                        "T"
                                                    )[0]
                                                }
                                                className="form-control"
                                                name="DT_FIM_FN"
                                                ref={register()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Empreendimento</label>
                                    <SelectComBusca
                                        name="ID_EMPREENDIMENTO"
                                        options={options}
                                        isMulti={true}
                                    />
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Etapa</label>
                                    <select
                                        name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS"
                                        className="form-control"
                                        defaultValue={
                                            props.filter
                                                ?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS
                                        }
                                        ref={register()}
                                    >
                                        <option></option>
                                        {lstEtapasAssistTec?.map((etapa) => (
                                            <option
                                                value={Number(
                                                    etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                )}
                                            >
                                                {
                                                    etapa.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                }
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </>
                        )}

                        {props.dsModulo === "Repasse" && (
                            <>
                                <div className="col-12 mt-3">
                                    <label>Data Inicial</label>
                                    <div className="row">
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_INICIAL_IN
                                                }
                                                name="DT_INICIAL_IN"
                                                ref={register()}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_INICIAL_FN
                                                }
                                                name="DT_INICIAL_FN"
                                                ref={register()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Data Final</label>
                                    <div className="row">
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_FINAL_IN
                                                }
                                                name="DT_FINAL_IN"
                                                ref={register()}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_FINAL_FN
                                                }
                                                name="DT_FINAL_FN"
                                                ref={register()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Empreendimento</label>
                                    <Select
                                        name="ID_EMPREENDIMENTO"
                                        ref={selectInputRef}
                                        options={options}
                                        isClearable
                                        isMulti
                                        onChange={(e) => {
                                            props.setIdEmpreendimento(
                                                e.map((value) => value?.value)
                                            );
                                        }}
                                        components={{
                                            DropdownIndicator: () => null,
                                            IndicatorSeparator: () => null,
                                        }}
                                        styles={customStyles}
                                        placeholder={""}
                                        noOptionsMessage={() => "Nenhuma opção"}
                                    />
                                </div>
                                <div className="col-12 mt-3">
                                    <LazySelect
                                        className="form-control"
                                        label="Categoria de Atendimento"
                                        name="ID_CATEGORIA_ATENDIMENTO"
                                        registerOptions={{
                                            valueAsNumber: true,
                                        }}
                                        {...FormMethods}
                                        controller={
                                            ListarCategoriaRepasseController
                                        }
                                        getDS={(s) =>
                                            s.DS_CATEGORIA_ATENDIMENTO
                                        }
                                        getKeyValue={(s) =>
                                            s.ID_CATEGORIA_ATENDIMENTO
                                        }
                                    >
                                        <option value={0}></option>
                                    </LazySelect>
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Status do Caso</label>
                                    <select
                                        className="form-control"
                                        name="DS_STATUS_CASO"
                                        ref={register()}
                                        defaultValue={
                                            props.filter?.DS_STATUS_CASO ??
                                            "Aberto"
                                        }
                                    >
                                        <option></option>
                                        <option>Aberto</option>
                                        <option>Fechado</option>
                                    </select>
                                </div>
                            </>
                        )}

                        {props.dsModulo === "EntregaChaves" && (
                            <>
                                <div className="col-12 mt-3">
                                    <label>Data Inicial</label>
                                    <div className="row">
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_INICIAL_IN
                                                }
                                                name="DT_INICIAL_IN"
                                                ref={register()}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_INICIAL_FN
                                                }
                                                name="DT_INICIAL_FN"
                                                ref={register()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Data Final</label>
                                    <div className="row">
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_FINAL_IN
                                                }
                                                name="DT_FINAL_IN"
                                                ref={register()}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="form-control"
                                                type="date"
                                                defaultValue={
                                                    props.filter?.DT_FINAL_FN
                                                }
                                                name="DT_FINAL_FN"
                                                ref={register()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Empreendimento</label>
                                    <Select
                                        name="ID_EMPREENDIMENTO"
                                        ref={selectInputRef}
                                        options={options}
                                        isClearable
                                        isMulti
                                        onChange={(e) => {
                                            props.setIdEmpreendimento(
                                                e.map((value) => value?.value)
                                            );
                                        }}
                                        components={{
                                            DropdownIndicator: () => null,
                                            IndicatorSeparator: () => null,
                                        }}
                                        styles={customStyles}
                                        placeholder={""}
                                        noOptionsMessage={() => "Nenhuma opção"}
                                    />
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Categoria de Atendimento</label>
                                    <SelectCategoriaAtendimento
                                        ID_MODULO={
                                            ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO
                                        }
                                        className={`form-control placeholder-dark-75`}
                                        control={control}
                                        name="ID_CATEGORIA_ATENDIMENTO"
                                        multiple
                                    />
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Etapa</label>
                                    <Select
                                        name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                                        placeholder={""}
                                        menuPlacement="auto"
                                        noOptionsMessage={() => "Nenhuma opção"}
                                        styles={customStyles}
                                        options={etapasOptionsVistoria}
                                        value={props.valueEtapa}
                                        ref={etapaRef}
                                        onChange={(e) =>
                                            props.setValueEtapa(
                                                e as SetStateAction<
                                                    | {
                                                          label: string;
                                                          value: number;
                                                      }[]
                                                    | null
                                                >
                                            )
                                        }
                                        components={{
                                            DropdownIndicator: () => null,
                                            IndicatorSeparator: () => null,
                                        }}
                                        isClearable
                                        isMulti
                                    />
                                </div>
                            </>
                        )}
                        {props.dsModulo === "Atendimento" ||
                        props.dsModulo === "AssistenciaTecnica" ||
                        props.dsModulo === "EntregaChaves" ? (
                            <div className="col-12 mt-3">
                                <label>Status do Caso</label>
                                <select
                                    className="form-control"
                                    name="DS_STATUS_CASO"
                                    ref={register()}
                                    defaultValue={
                                        props.filter?.DS_STATUS_CASO ?? "Aberto"
                                    }
                                >
                                    <option></option>
                                    <option>Aberto</option>
                                    <option>Fechado</option>
                                    <option>Cancelado</option>
                                </select>
                            </div>
                        ) : null}

                        <div className="col-12 mt-3">
                            <label>Protocolo</label>
                            <input
                                className="form-control"
                                type="number"
                                name="ID_CASO"
                                defaultValue={props.filter?.ID_CASO}
                                ref={register({
                                    valueAsNumber: true,
                                })}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Atendente</label>
                            <LazySelect
                                className="form-control"
                                name="ID_USUARIO"
                                controller={ListarUsuariosController}
                                filter={(u) => u.FL_ATIVO}
                                getDS={(u) => u.DS_NOME}
                                getKeyValue={(u) => u.ID_USUARIO}
                                ref={register()}
                                defaultValue={props.filter?.ID_USUARIO}
                                setValue={setValue}
                            >
                                <option></option>
                            </LazySelect>
                        </div>
                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    window.sessionStorage.removeItem(
                                        "FILTRO_ATENDIMENTOS_DO_CLIENTE"
                                    );
                                    props.setFilter(props.filtroInicial);
                                    reset(props.filtroInicial);
                                    props.setPage(1);
                                    limparFiltros();
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </form>
                </FormProvider>
            </StickyToolbar>
        </>
    );
}
